import { Component, OnInit, Input } from '@angular/core';
// Services
import { ActivatedRoute } from '@angular/router';

// External
import * as lodash from 'lodash';
import { ApiService } from "./../../services/api";




@Component({
    selector: 'app-tee-time-booking',
    templateUrl: './tee-time-booking.component.html'
})
export class TeeTimeBookingComponent implements OnInit {
    public teeTimes: Array<any>
    public order = 'startDate';
    public reverse = true;
    public filterargs: any;
    @Input() userId: String
    public currentTime = new Date().getTime() / 1000
    constructor(private route: ActivatedRoute, private apiService: ApiService) {
        this.filterargs = {
            bookingId: "",
            createdDate: ''
        }
    }
    async   ngOnInit() {
        this.teeTimes = []
        if (this.userId) {
            let res = await this.apiService.list("user-booking-teetimes/" + this.userId)
            console.log(res);

            for (let i = 0; i < res.length; i++) {
                const element = res[i];
                this.teeTimes.push(element)


            }
        } else {
            let res = await this.apiService.list("user-booking-teetimes")
            console.log(res);

            for (let i = 0; i < res.length; i++) {
                const element = res[i];
                lodash.forEach(element, (item, key) => {
                    item.teestamp = new Date(item.teetime).getTime() / 1000
                    this.teeTimes.push(item)
                })

            }
        }

    }
    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }
        this.order = value;
    }
}
